var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.item.hasDetail)?_c('md-button',{staticClass:"md-just-icon md-success md-simple table-action",nativeOn:{"click":function($event){return _vm.triggerDetail($event)}}},[_c('md-icon',[_vm._v("visibility")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }